/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const deliveryOrders = sqliteTable('delivery_orders', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  do_number: text('do_number'),
  purchase_order_id: text('purchase_order_id'),
  source_type: text('source_type'),
  supplier_id: text('supplier_id'),
  supplier_name: text('supplier_name'),
  supplier_invoice_number: text('supplier_invoice_number'),
  reference: text('reference'),
  date_raised: text('date_raised'),
  delivery_date: text('delivery_date'),
  received_date: text('received_date'),
  amounts_are: text('amounts_are'),
  subtotal: real('subtotal'),
  tax_rate: real('tax_rate'),
  tax_amount: real('tax_amount'),
  invoice_total: real('invoice_total'),
  notes: text('notes'),
  status: text('status'),
  received_by: text('received_by'),
  cancelled_at: text('cancelled_at'),
  cancelled_by: text('cancelled_by'),
  cancel_reason: text('cancel_reason'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
